import { create } from 'zustand'

type ResetPasswordState = {
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (pwd: string) => void;
  sentEmail: boolean;
  setSentEmail: (sent: boolean) => void;
  confirmPassword: string;
  setConfirmPassword: (pwd: string) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  isFormValid: boolean;
  setIsFormValid: (isValid: boolean) => void;
  emailError: string | null;
  setEmailError: (error: string | null) => void;
  passwordError: string | null;
  setPasswordError: (error: string | null) => void;
}

export const useResetPasswordStore = create<ResetPasswordState>((set) => ({
  email: '',
  setEmail: (email) => set((state) => ({email: email})),
  sentEmail: false,
  setSentEmail: (sent) => set((state) => ({sentEmail: sent})),
  password: '',
  setPassword: (pwd) => set((state) => ({password: pwd})),
  confirmPassword: '',
  setConfirmPassword: (pwd) => set((state) => ({confirmPassword: pwd})),
  loading: false,
  setLoading(loading) {
      return set((state) => {
        return {loading: loading}
      })
  },
  isFormValid: false,
  setIsFormValid: (isValid) => set((state) => ({isFormValid: isValid})),
  emailError: null,
  setEmailError: (e) => set((state) => ({emailError: e})),
  passwordError: null,
  setPasswordError: (e) => set((state) => ({passwordError: e}))
}))
